import React, { FC } from 'react';
import cx from 'classnames';
import { graphql, Link, useStaticQuery } from 'gatsby';
import Card, { CardGrid } from '@/components/Common/Card';
import { PropsWithClassName } from '@/types/common';
import Section from '@/components/Common/Section';
import { getLocalisedDatoValueOrFallback } from '@/utils/i18n';
import { useI18n } from '@/context/I18n';
import Asset from '@/components/Common/Asset';
import routes from '@/routes';
import * as styles from './DiscoverCards.module.scss';

type Props = PropsWithClassName;

const routeByKey = {
  sustainability: routes.sustainability,
  services: routes.contact,
  materials: (locale: string) => routes.finishGroupCategories(locale),
};
const DiscoverCards: FC<Props> = ({ className }) => {
  const data = useStaticQuery<Queries.AllDiscoverQuery>(graphql`
    query AllDiscover {
      discover: allDatoCmsDiscover {
        nodes {
          _allTitleLocales {
            value
            locale
          }

          _allContentLocales {
            value {
              ...DatoCmsCardGroup
            }
            locale
          }
        }
      }
    }
  `);
  const { locale } = useI18n();
  const discover = data.discover.nodes[0];
  const title = getLocalisedDatoValueOrFallback(discover._allTitleLocales, locale);
  const content = getLocalisedDatoValueOrFallback(discover._allContentLocales, locale);

  return (
    <Section className={cx(styles.main, className)} title={title}>
      <CardGrid>
        {content?.cards?.map((card, index) => (
          <Card
            key={index}
            as={Link}
            to={routeByKey[card?.key as keyof typeof routeByKey]?.(locale) ?? ''}
            image={<Asset asset={card?.asset} />}
            pretitle={card?.pretitle}
            title={<span className={styles.title}>{card?.title}</span>}
            hasAspectRatio
          />
        ))}
      </CardGrid>
    </Section>
  );
};

export default DiscoverCards;
